import { TouchableOpacity, Image, StyleSheet } from 'react-native';
import React from 'react';
import { useNavigation } from '@react-navigation/native';
import Config from '../../libraries/ReactNativeConfig';

export default function WebHeaderLogo() {
  const navigation = useNavigation();
  const handlePress = () => {
    navigation.replace('TabNavigator');
  };

  return (
    <TouchableOpacity onPress={handlePress} style={styles.container}>
      <Image
        source={{ uri: Config.WEB_HEADER_LOGO }}
        style={styles.logo}
      />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    left: 43,
    right: 40,
    top: 8,
    alignSelf: 'center',
    overflow: 'hidden',
  },
  logo: {
    width: 40,
    height: 40,
  },
});
